export { default } from './BlogAuthor'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Blog/BlogAuthor/index.js